import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataSalesSupportPersonsActions } from "./sales-support-persons.actions";

// **************************************************************************
// SALES SUPPORT PERSONS REDUCER
// **************************************************************************

const load = on(DataSalesSupportPersonsActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        salesSupportPerson: {
            ...state.data.salesSupportPerson,
            salesSupportPersonsLoading: true,
        },
    },
}));

const loadSuccess = on(DataSalesSupportPersonsActions.loadSuccess, (state: ApplicationStore, { salesSupportPersons }) => ({
    ...state,
    data: {
        ...state.data,
        salesSupportPerson: {
            ...state.data.salesSupportPerson,
            salesSupportPersons,
            salesSupportPersonsLoading: false,
        },
    },
}));

const loadFailure = on(DataSalesSupportPersonsActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        salesSupportPerson: {
            ...state.data.salesSupportPerson,
            salesSupportPersonsLoading: false,
        },
    },
}));

export const salesSupportPersonsReducer = [load, loadSuccess, loadFailure];
